import type { TaskDefinitionFormSchema } from "api";
import type { FC, PropsWithChildren } from "react";

interface TaskDefinitionViewProps {
  definition: TaskDefinitionFormSchema;
}

const TaskDefinitionView: FC<TaskDefinitionViewProps> = ({ definition }) => {
  return (
    <table className="table-auto border-collapse border border-slate-500">
      <tbody>
        <TaskDefinitionTableRow label="ID">
          {definition.id}
        </TaskDefinitionTableRow>

        {definition.family && (
          <TaskDefinitionTableRow label="Family">
            {definition.family}
          </TaskDefinitionTableRow>
        )}

        <TaskDefinitionTableRow label="Image">
          {[definition.image, definition.version].filter(Boolean).join(":")}
        </TaskDefinitionTableRow>

        {definition.entrypoint && (
          <TaskDefinitionTableRow label="Entrypoint">
            {definition.entrypoint.join(" ")}
          </TaskDefinitionTableRow>
        )}

        {definition.command && (
          <TaskDefinitionTableRow label="Command">
            {definition.command.join(" ")}
          </TaskDefinitionTableRow>
        )}

        {!!definition.env?.length && (
          <TaskDefinitionTableRow label="Environment variables">
            <ul className="list-disc pl-4 font-mono">
              {definition.env.map(({ key, value }) => (
                <li key={key}>{`${key}=${value}`}</li>
              ))}
            </ul>
          </TaskDefinitionTableRow>
        )}

        {!!definition.secrets?.length && (
          <TaskDefinitionTableRow label="Secrets">
            <ul className="list-disc pl-4 font-mono">
              {definition.secrets.map(({ key, value }) => (
                <li key={key}>{`${key}=${value}`}</li>
              ))}
            </ul>
          </TaskDefinitionTableRow>
        )}
      </tbody>
    </table>
  );
};

interface TaskDefinitionTableRowProps {
  label: string;
}

const TaskDefinitionTableRow: FC<
  PropsWithChildren<TaskDefinitionTableRowProps>
> = ({ label, children }) => {
  return (
    <tr>
      <td className="border border-slate-500 p-2 min-w-32">{label}</td>
      <td className="border border-slate-500 p-2">{children}</td>
    </tr>
  );
};

export default TaskDefinitionView;
